import { select, scaleLinear } from 'd3'
import World from './assets/world.json'
import { geoPath, geoOrthographic } from 'd3-geo'
import { feature } from 'topojson'
import { useEffect, useRef } from 'react'
import { chakra } from '@chakra-ui/react'

export default ({
  size = 400,
  land = 'green', water = 'blue',
}) => {
  const svgRef = useRef()
  const pad = size * 0.5 // amount to pad the viewBox

  useEffect(() => {
    const projection = (
      geoOrthographic()
      .scale(size / 2)
      .translate([size / 2, size / 2])
      .clipAngle(90)
    )
    const path = (
      geoPath()
      .projection(projection)
    )
    const λ = (
      scaleLinear()
      .domain([0, size])
      .range([-180, 180])
    )
    const φ = (
      scaleLinear()
      .domain([0, size])
      .range([90, -90])
    )
    const svg = (
      select(svgRef.current)
      .attr('width', size)
      .attr('height', size)
    )

    svg.append('circle')
    .attr('r', size / 2)
    .attr('filter', 'url(#glow)')

    svg.append('circle')
    .attr('r', size / 2)
    .attr('fill', water)

    svg.append('path')
    .datum(feature(World, World.objects.land))
    .attr('transform', `translate(-${size / 2}, -${size / 2})`)
    .attr('class', 'land')
    .attr('d', path)
    .attr('fill', land)

    const scrollSpeed = 100
    let current = 0
    const bgscroll = () => {
      current += 1
      projection.rotate([λ(current), 0])
      svg.selectAll('path').attr('d', path)
    }
    setInterval(bgscroll, scrollSpeed)
  }, [size, water, land])

  return (
    <g
      transform={
        `translate(-${size / 2}, -${size / 2})`
      }
    >
      <chakra.svg
        ref={svgRef}
        viewBox={[
          -size / 2 - pad, -size / 2 - pad,
          size + 2 * pad, size + 2 * pad,
        ].join(' ')}
        _hover={{
          path: { fill: 'purple' },
          circle: { fill: '#111' },
        }}
      >
        <defs>
          <filter id="glow">
            <feFlood
              floodOpacity="0.8"
              floodColor="white"
              result="flood"
            />
            <feComposite
              in="flood"
              in2="SourceGraphic"
              operator="in"
              result="composite"
            />
            <feGaussianBlur
              in="composite"
              stdDeviation="14"
              result="blur"
            />
            <feComposite
              in="SourceGraphic"
              in2="blur"
              operator="over"
            />
          </filter>
        </defs>
      </chakra.svg>
    </g>
  )
}